import { createContext, useContext, useState } from 'react';
import { useClient } from './client';
import { useAsyncEffect } from '../hooks';

const UserContext = createContext('');

export function UserProvider({ children }) {
	const [user, setUser] = useState('');
	const client = useClient();

	useAsyncEffect(async () => {
		try {
			const response = await client('/oms/user');

			if (response.ok) setUser(await response.text());
		} catch (err) {
			console.error(err);
		}
	}, []);

	return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

export const useUser = () => useContext(UserContext);
